const reportsServiceConfig = {
    getPanelReports : `panel-reports`,
    getUserDetails :`user-details-by-feature`,
    getUserSpecificReports : `user-specific-report`,
    getTaskReportChart : `task-report-admin`
};


export default reportsServiceConfig;